// extracted by mini-css-extract-plugin
module.exports = {"content":"ChangeEmail_content__JcBHd","social":"ChangeEmail_social__3EL7m","input":"ChangeEmail_input__3pxg0","button":"ChangeEmail_button__1ai6_"};